import React from 'react';
import ServiceDetailModal from './ServiceDetailModal';

export type { ServiceDetailType, ServiceReview } from './ServiceDetailModal';

type ServiceEditModalProps = Omit<React.ComponentProps<typeof ServiceDetailModal>, 'initialIsEditing'>;

const ServiceEditModal: React.FC<ServiceEditModalProps> = (props) => {
    return <ServiceDetailModal {...props} initialIsEditing={true} />;
};

export default ServiceEditModal;
